<div class="flex mb-7" *ngIf="breadcrumbs && breadcrumbs.length > showFromLevel">
  <lh-back-button *ngIf="!disableBackButton && breadcrumbs.length > 1"
    [backRoute]="breadcrumbs[breadcrumbs.length - 2].path" class="back-button"></lh-back-button>
  <patternlib-breadcrumb class="my-auto">
    <patternlib-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs">
      <a [routerLink]="breadcrumb.path" class="no-underline">{{ breadcrumb.label | translate: breadcrumb?.translationParams }}</a>
    </patternlib-breadcrumb-item>
  </patternlib-breadcrumb>
</div>